import { css } from '@emotion/core'
import { IFontStyles, IRawStyle } from 'office-ui-fabric-react'
import { ThemeProps } from './types'

export const themeFont =
  <T extends ThemeProps = ThemeProps>(
    selector: ((themeFonts: IFontStyles) => IRawStyle) | keyof IFontStyles
  ) =>
  ({ theme }: T) =>
    css(
      (typeof selector === 'function'
        ? selector(theme!.fonts)
        : theme!.fonts[selector]) as any
    )
